import { IsArray, IsOptional, IsBoolean, ValidateNested } from "class-validator";
import { Type } from "class-transformer";

import { IDogShowClassesUpdate } from "./dog-show-classes-update.interface";
import { ScoreDogClassExtDto } from "./score-dog-class-ext.dto";

export class DogShowClassesUpdateDto implements IDogShowClassesUpdate {
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => ScoreDogClassExtDto)
  dog_classes: ScoreDogClassExtDto[];

  @IsOptional()
  @IsBoolean()
  update_show_registration?: boolean;

  @IsOptional()
  @IsArray()
  remove_score_ids?: string[];
}
